import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('StrappingChartProfilesFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getChartProfilesList: function () {
            return $http.get(settings.ApiURL + settings.StrappingChartProfilesURL + "/list/");
        },
        getChartProfilesByID: function (id) {
            return $http.get(settings.ApiURL + settings.StrappingChartProfilesURL +"/"+ id);
        },
        getOrientation: function() {
            return $http.get(settings.ApiURL + settings.StrappingChartProfilesURL + "/orientation");
        },
        getShape: function() {
            return $http.get(settings.ApiURL + settings.StrappingChartProfilesURL + "/shape");
        },
        saveChartProfile: function (chartProfile) {
            return $http.put(settings.ApiURL + settings.StrappingChartProfilesURL , chartProfile);
        },
        deleteChartProfile: function (id) {
            return $http.delete(settings.ApiURL + settings.StrappingChartProfilesURL + "/" + id);
        },
        getNewChartProfile: function () {
            return $http.get(settings.ApiURL + settings.StrappingChartProfilesURL + "/newchartprofile");
        }
    };
}]);

app.controller('StrappingChartProfilesController', function ($q, $scope, StrappingChartProfilesFactory, $rootScope, settings, masterFactory) {
    $rootScope.pageTitle = "Strapping Chart Profile";    
    $scope.chartProfiles = [];
    $scope.chartProfile = {};
    $scope.Orientations = [];
    $scope.Shapes = [];
    $scope.newChartProfile = {};
    $scope.error = "";
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.pageSize = 20;
    $scope.duplicate = false;

    // Initialization - this runs on load
    var init = function (pageIndex) {
        masterFactory.verifyAuthentication();        

        $('#loadingModal').modal({ backdrop: 'static' });
        $q.all([
            StrappingChartProfilesFactory.getOrientation().success(function (data) {
                $scope.Orientations = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            StrappingChartProfilesFactory.getShape().success(function (data) {
                $scope.Shapes = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            StrappingChartProfilesFactory.getNewChartProfile().success(function (data) {
                $scope.newChartProfile = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            })
        ]).then(function () {
            StrappingChartProfilesFactory.getChartProfilesList().success(function (data) {
                $scope.chartProfiles = data;
                $scope.refreshGrid(0);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        });
    };

    init(0);

    // Grid renderers
    $scope.refreshGrid = function (pageIndex) {
        $('#gridChartProfile').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.chartProfiles,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Data Found",            
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            contentReadyAction: grdReadyAction,
            selection: { mode: 'single' },
            paging: {
                pageSize: $scope.pageSize,
                pageIndex: pageIndex
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: true
            },
            groupPanel: {
                visible: false,
            },
            columns: [
               {
                   caption: 'Profile ID',
                   dataField: 'ProfileId',
                   cssClass: 'Number',
                   dataType: 'string',
                   alignment: 'center',
                   width: 150
               },
               {
                   caption: 'Description',
                   dataField: 'ProfileDescription',
                   cssClass: 'Name',
                   dataType: 'string',
                   alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.ProfileDescription)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                $scope.error = "";
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $('#loadingModal').modal({ backdrop: 'static' });
                    StrappingChartProfilesFactory.getChartProfilesByID(selectedRowsInfo.selectedRowsData[0].Id).success(function (data) {
                        $scope.chartProfile = data;
                        $scope.refreshIncrementsSettings();
                        $scope.isFormVisible = true;
                        $scope.isDeleteVisible = true;
                        ToggleYellowToGreen();
                        $rootScope.pageTitle = "Strapping Chart Profiles";
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    });
                }
            }
        });
    };

    $scope.refreshIncrementsSettings = function () {
        $('#gridIncrementsSettings').dxDataGrid({
            dataSource: $scope.chartProfile.StrappingChartProfileIncrements,
            columns: [
                {
                    caption: 'Increment',
                    dataField: 'Increment',
                    dataType: 'number',
                    validationRules: [{ type: 'required' }],
                    alignment: 'center',
                    width: '50%',
                },
                {
                    caption: 'Volume',
                    dataField: 'IncrementVolume',
                    dataType: 'number',
                    validationRules: [{ type: 'required' }],
                    width: '50%',
                    alignment: 'center',
                }
            ],            
            editing: {
                editEnabled: true,
                insertEnabled: true,
                removeEnabled: true
            },
            filterRow: {
                visible: false
            },
            groupPanel: {
                visible: false,
            },
            height: 470,
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            paging: {
                pageSize: 30
            },
            sorting: {
                mode: 'none'
            },
            rowAlternationEnabled: false,
            rowInserted: function (rowInfo) {
                rowInfo.data.Id = -1;
            },
            selection: { mode: 'single' },
            showColumnLines: true,
            showRowLines: false,
            showBorders: true
        }).dxDataGrid('instance');

        var grd = document.getElementById("gridIncrementsSettings");
        if (grd.getElementsByClassName("dx-datagrid-header-panel")[0].childNodes.length == 1)
            $('<span > Increments and Volume </span>').appendTo(grd.getElementsByClassName("dx-datagrid-header-panel")[0]);
    };

    // Button click functions and submit form function
    $scope.addNewEntity = function () {
        $rootScope.pageTitle = "New Chart Profile";
        $scope.isFormVisible = true;
        $scope.isDeleteVisible = false;
        $scope.chartProfile = angular.copy($scope.newChartProfile);
        $scope.chartProfile.StrappingChartProfileIncrements = [];
        $scope.refreshIncrementsSettings();
        ToggleGreenToYellow();
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            StrappingChartProfilesFactory.deleteChartProfile($scope.chartProfile.Id).success(function (data) {
                StrappingChartProfilesFactory.getChartProfilesList().success(function (data) {
                    var dataGrid = $('#gridChartProfile').dxDataGrid('instance');
                    var pageIndex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    $scope.chartProfiles = data;
                    $scope.cancelForm();
                    $scope.refreshGrid(pageIndex);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted successfully' });
                });
                
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }
    };

    $scope.cancelForm = function () {
        var dataGrid = $('#gridChartProfile').dxDataGrid('instance');
        dataGrid.clearSelection();             
        $scope.isFormVisible = false;        
        $scope.strappingChartProfilesForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    };

    $scope.reset = function (type) {
        if (type == 'update') { 
            $('#loadingModal').modal({ backdrop: 'static' });            
            StrappingChartProfilesFactory.getChartProfilesByID($scope.chartProfile.Id).success(function (data) {
                $scope.chartProfile = data;
                $scope.refreshIncrementsSettings();
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        }
        else {
            angular.copy($scope.newChartProfile, $scope.chartProfile);
            $scope.refreshIncrementsSettings();
        }   
        
        $scope.strappingChartProfilesForm.$setPristine();
        $scope.strappingChartProfilesForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Chart Profile details were reset' });        
    };

    $scope.submitForm = function () {
        const unique = new Set();

        $scope.duplicate = $scope.chartProfile.StrappingChartProfileIncrements.some(element => unique.size === unique.add(element.Increment).size);

        if($scope.duplicate) {
            $('#error_message').fadeIn();
            $scope.strappingChartProfilesForm.submitted = true;
            $('#error_message').fadeOut(5000);
        }
        else if ($scope.strappingChartProfilesForm.$valid && $scope.chartProfile.StrappingChartProfileIncrements.length > 0) {
            $scope.saveUllageChartProfile();
            $scope.strappingChartProfilesForm.submitted = false;
        }
        else {
            $scope.strappingChartProfilesForm.submitted = true;
        }
    };

    $scope.saveUllageChartProfile = function () {
        if (IsUndefinedOrNull($scope.chartProfile.Id) || $scope.chartProfile.Id <= 0) {
            $scope.chartProfile.Id = -1;
        }
        StrappingChartProfilesFactory.saveChartProfile($scope.chartProfile).success(function (data) {
            StrappingChartProfilesFactory.getChartProfilesList().success(function (data) {
                var dataGrid = $('#gridChartProfile').dxDataGrid('instance');
                var pageindex = dataGrid.pageIndex();
                $scope.pageSize = dataGrid.pageSize();
                $scope.chartProfiles = data;
                if ($scope.chartProfile.Id > 0) {
                    $scope.refreshGrid(pageindex)
                }
                else {
                    $scope.cancelForm();
                    $scope.refreshGrid(pageindex);
                }
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                if ($scope.chartProfile.Id > 0) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated successfully' });
                }
                else {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created successfully' });
                }
            });                           
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        }).finally(function () {            
        });
    }

    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridChartProfile', settings.GridMarginHeight);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridChartProfile', settings.GridMarginHeight);
    }

    collapsibleHeaderClickEvent($scope);

    $scope.closeAlert = function () {
        $scope.error = null;
    };    

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.filter = function (input, id) {
        var i = 0, len = input.length;
        for (; i < len; i++) {
            if (+input[i].Id == +id) {
                return input[i];
            }
        }
        return null;
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

});
